import { neutral } from '@bloomfieldrobotics/canopy';
import {
  Link,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MenuPaper } from '../../../commonUI/Menu/MenuPaper';

const StyledTableCell = styled(TableCell)({
  border: 0,
});

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.02)',
  color: theme.vars.palette.text.secondary,
  borderBottom: `0.5px solid ${neutral[800]}`,
}));

type Props = {
  customerID: string;
};

export const GrapeReportsList = ({ customerID }: Props) => {
  const navigate = useNavigate();
  return (
    <MenuPaper sx={{ width: '100%', padding: 0 }}>
      <Table>
        <StyledTableHead>
          <TableRow>
            <StyledTableCell>
              <Typography variant='body2'>Name</Typography>
            </StyledTableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          <TableRow>
            <StyledTableCell>
              <Link
                component='button'
                onClick={() => {
                  if (customerID) {
                    navigate(
                      `/reports/grape/clusters?customerID=${customerID}`
                    );
                  }
                }}
                sx={{
                  textDecoration: 'none',
                  border: 'none',
                  background: 'none',
                  padding: 0,
                  cursor: 'pointer',
                }}
              >
                <Typography variant='body2' color='textPrimary'>
                  Clusters
                </Typography>
              </Link>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </MenuPaper>
  );
};
